export enum Disciplines {
  Indoor = "INDOOR",
  Outdoor = "OUTDOOR",
  Hockey5S = "HOCKEY5S",
  Parahockey = "PARAHOCKEY",
  Beach = "BEACH",
}
